

import React, { useState, useRef } from "react";
import Tooltip from '@mui/material/Tooltip';
import TextField from '@mui/material/TextField';

export const LucketEditText = ({ lucket, luckets, updateLucket, editTitle, editDescription, isExpanded, addingChild, editIcon }) => {
    const [duplicateName, setDuplicateName] = useState(false);
    const [nameValue, setNameValue] = useState(lucket?.name || "");
    const [descValue, setDescValue] = useState(lucket?.description || "");

    const nameDebounceRef = useRef();
    const descDebounceRef = useRef();

    const handleNameChange = (e) => {
        const value = e.target.value;
        setNameValue(value);
        // Check for duplicate name (case-insensitive, exclude current lucket)
        const isDuplicate = luckets.some(l => l.name === value && l.id !== lucket.id);
        setDuplicateName(isDuplicate);
        if (nameDebounceRef.current) clearTimeout(nameDebounceRef.current);
        nameDebounceRef.current = setTimeout(() => {
            updateLucket(value, "name");
        }, 500);
    };

    const handleDescChange = (e) => {
        const value = e.target.value;
        setDescValue(value);
        if (descDebounceRef.current) clearTimeout(descDebounceRef.current);
        descDebounceRef.current = setTimeout(() => {
            updateLucket(value, "description");
        }, 500);
    };

    if (editTitle || editDescription || isExpanded) {
        return (
            <div className="editText" style={{ marginBottom: !addingChild ? "50px" : undefined, display: "flex", flexDirection: "column" }}>
                {editTitle && (
                    <Tooltip title="Change Name">
                        <TextField
                            multiline
                            variant="filled"
                            helperText={duplicateName ? "Please Enter Unique Name" : undefined}
                            color={duplicateName ? "error" : "primary"}
                            style={{ margin: "10px", marginBottom: !editDescription ? "10px" : "0px" }}
                            value={nameValue}
                            onChange={handleNameChange}
                            placeholder="Enter bucket name..."
                        />
                    </Tooltip>
                )}
                {(editDescription || isExpanded) && (
                    <Tooltip title="Change Description">
                        <TextField
                            multiline
                            variant="filled"
                            style={{ margin: "10px", marginBottom: !editIcon ? "10px" : "0px" }}
                            value={descValue}
                            onChange={handleDescChange}
                            placeholder="Enter description..."
                        />
                    </Tooltip>
                )}
            </div>
        );
    }
    return null;
};